import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const CheckPaymentDetailsSection = styled.div`
  margin-left: auto;
`;

export const RightParagraph = styled.div`
  padding-left: ${rem(50)};
`;